export default __webpack_public_path__ + "static/media/017-annoyed.1de7f896.svg";